import { render, staticRenderFns } from "./FrameworkList.vue?vue&type=template&id=ae965c52"
import script from "./FrameworkList.vue?vue&type=script&lang=js"
export * from "./FrameworkList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports